// src/components/Quotation/QuotationStatusBadge.jsx
import React from "react";

const STATUS_COLORS = {
  DRAFT:    { bg: "#F3F4F6", text: "#374151", border: "#D1D5DB" },
  SENT:     { bg: "#EFF6FF", text: "#1A56DB", border: "#BFDBFE" },
  APPROVED: { bg: "#ECFDF5", text: "#059669", border: "#A7F3D0" },
  REJECTED: { bg: "#FEF2F2", text: "#EF4444", border: "#FECACA" },
  INVOICED: { bg: "#F5F3FF", text: "#7C3AED", border: "#DDD6FE" },
};

const STATUS_LABELS = {
  DRAFT:    "Draft",
  SENT:     "Sent",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  INVOICED: "Invoiced",
};

const QuotationStatusBadge = ({ status }) => {
  const colors = STATUS_COLORS[status] || STATUS_COLORS.DRAFT;
  return (
    <span style={{
      display: "inline-block",
      padding: "3px 12px",
      borderRadius: 20,
      fontSize: 12,
      fontWeight: 600,
      background: colors.bg,
      color: colors.text,
      border: `0.5px solid ${colors.border}`,
      letterSpacing: "0.03em"
    }}>
      {STATUS_LABELS[status] || status}
    </span>
  );
};

export default QuotationStatusBadge;
